import Container from "react-bootstrap/Container";
import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";
import { Button, Card, Row } from "react-bootstrap";
import Parser from "html-react-parser";

const itinerary_slide_images = [
  {
    src: "https://onegirlwandering-com.s3.us-west-2.amazonaws.com/antarctica-2025/images/3T8A2146.jpg",
  },
  {
    src: "https://onegirlwandering-com.s3.us-west-2.amazonaws.com/antarctica-2025/images/3T8A2987.jpg",
  },
  {
    src: "https://onegirlwandering-com.s3.us-west-2.amazonaws.com/antarctica-2025/images/3T8A3102-3.jpg",
  },
  {
    src: "https://onegirlwandering-com.s3.us-west-2.amazonaws.com/antarctica-2025/images/3T8A3591-3.jpg",
  },
  {
    src: "https://onegirlwandering-com.s3.us-west-2.amazonaws.com/antarctica-2025/images/3T8A2253.jpg",
  },
];


const itinerary_array = (data) => {
  return (
    <div>
      {data
        .reduce((rows, item, index) => {
          const rowIndex = Math.floor(index / 3);
          if (!rows[rowIndex]) rows[rowIndex] = [];
          rows[rowIndex].push(
            <Col md={4} key={`itinerary-day-card-col-${index}}`}>
              <ItineraryDayCards id={index} title={item.title}>
                {Parser(item.description)}
              </ItineraryDayCards>
            </Col>
          );
          return rows;
        }, [])
        .map((row, index) => (
          <Row key={index} style={{paddingBottom: "20px"}}>{row}</Row>
        ))}
    </div>
  );
};

function ItineraryDetails(props) {
  const { data } = props;
  return (
    <div style={{ paddingTop: "0px" }}>
      <Container>
        <Row>
          <Col>
            <Carousel className="text-center" style={{ display: "none" }}>
              {itinerary_slide_images.map((image, i) => {
                return (
                  <Carousel.Item key={`ItineraryDetails-Carousel${i}`}>
                    <img
                      src={image.src}
                      className="img-fluid"
                      alt={image.title}
                    />{" "}
                    {/* <Carousel.Caption>{image.title}</Carousel.Caption> */}
                  </Carousel.Item>
                );
              })}
            </Carousel>
          </Col>
        </Row>
        <br />

        <div className="itinerary-day-cards">
          {itinerary_array(data)}
          {/* {data.map((item, i) => {
            return (
              <>
                <Col md={4} key={`itinerary-day-card-col-${i}}`}>
                  <ItineraryDayCards id={i} title={item.title}>
                    {Parser(item.description)}
                  </ItineraryDayCards>
                </Col>
                <br />
              </>
            );
          })} */}
        </div>
      </Container>
    </div>
  );
}

export default ItineraryDetails;

function ItineraryDayCards(props) {
  const [hideReadmore, setHideReadmore] = useState(true);

  function toggleReadMore() {
    setHideReadmore(false);
    var elements = findChild(`Itinerary-${props.id}`, "collapse");

    if (elements) {
      elements.classList.remove("collapse");
      elements.classList.add("collapse.show");
    }
  }

  function findChild(idOfElement, idOfChild) {
    let element = document.getElementById(idOfElement);
    return element.querySelector("[class=" + idOfChild + "]");
  }

  return (
    <Card>
      <Card.Body id={`Itinerary-${props.id}`} aria-controls="collapse">
        <Card.Title>{props.title}</Card.Title>
        <Card.Text>
          <h5>{props.subtitle}</h5>
          {props.children}
        </Card.Text>
        <p
          className="readmore-link"
          onClick={toggleReadMore}
          style={{ display: false ? "block" : "none" }}
        >
          Read More
        </p>
      </Card.Body>
    </Card>
  );
}
